module.exports = __webpack_public_path__ + "static/dashboard-f722467de2605ded23128d96b04e85cc.png";